import { VMain } from 'vuetify/lib/components/VMain';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"height":"100%"}},[(_vm.userClient)?_c('client-settings-modal'):_vm._e(),_c('profile-modal'),_c('app-toolbar',{staticClass:"header"}),(!_vm.isMember && !_vm.isProfileUpdate)?_c('app-sidebar'):_vm._e(),_c(VMain,{attrs:{"app":""}},[_c('transition',{attrs:{"name":"fade","mode":"out-in","appear":""}},[_c('router-view')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }